import React from 'react'
import { useTranslation } from 'react-i18next'
import { ContainedButtonVariant } from '../Buttons/ContainedButton'
import { TextButtonVariant } from '../Buttons/TextButton'
import ConfirmWithButtonsModal from './ConfirmWithButtonsModal'

interface NotificationConfirmDeleteModalProps {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
  notificationName: string
}

const NotificationConfirmDeleteModal: React.FC<
  NotificationConfirmDeleteModalProps
> = ({ isOpen, onConfirm, onCancel, notificationName }) => {
  const { t } = useTranslation()
  return (
    <ConfirmWithButtonsModal
      isOpen={isOpen}
      title={t(
        'Notification.NotificationConfirmDeleteModal.Title',
        'Delete Notification'
      )}
      question={t(
        'Notification.NotificationConfirmDeleteModal.Question',
        `Are you sure you want to delete the notification: `
      ) + notificationName + '?'}
      questionProps={{ variant: 'body1', align: 'center' }}
      confirmVariant={ContainedButtonVariant.YesDelete}
      cancelVariant={TextButtonVariant.NoCancel}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  )
}

export default NotificationConfirmDeleteModal